import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import Link from '@/components/utils/Link';
import { URL } from '@/constants';
import { useRouter } from 'next/router';
import { i18n } from './i18n';

export default function AADS({ theme = 'black', style = {} }) {
    const { APP_ANDROID, APP_IOS, APK_OVERSEAS, APK_CN } = URL;
    const { locale = 'us' } = useRouter();
    const getAppDataLayer = (type: string) => ({
        event: 'uaEvent',
        event_name: 'ecoflow_app',
        button_name: type,
    });
    const {
        title,
        desc,
        item1_subtitle,
        item1_title,
        item1_desc,
        item2_subtitle,
        item2_title,
        item2_desc,
        item3_subtitle,
        item3_title,
        item3_desc,
        list1_subtitle,
        list1_title,
        list1_desc,
        list2_subtitle,
        list2_title,
        list2_desc,
        list3_subtitle,
        list3_title,
        list3_desc,
        tip,
    } = i18n[locale] || i18n['en'];

    const items = [
        {
            subtitle: item1_subtitle,
            title: item1_title,
            desc: item1_desc,
            img: require('@publicLocal/app-point/pc/ds_adv_1.jpg'),
        },
        {
            subtitle: item2_subtitle,
            title: item2_title,
            desc: item2_desc,
            img: require('@publicLocal/app-point/pc/ds_adv_2.jpg'),
        },
        {
            subtitle: item3_subtitle,
            title: item3_title,
            desc: item3_desc,
            img: require('@publicLocal/app-point/pc/ds_adv_3.jpg'),
        },
    ];

    const senceList = [
        {
            subTitle: list1_subtitle,
            title: list1_title,
            desc: list1_desc,
            img: require('@publicLocal/app-point/pc/ds_adv_4.jpg'),
        },
        {
            subTitle: list2_subtitle,
            title: list2_title,
            desc: list2_desc,
            img: require('@publicLocal/app-point/pc/ds_adv_5.jpg'),
        },
        {
            subTitle: list3_subtitle,
            title: list3_title,
            desc: list3_desc,
            img: require('@publicLocal/app-point/pc/ds_adv_6.jpg'),
        },
    ];

    return (
        <div
            className={`${css.AADS} app-adv-ds GtmModuleData-section`}
            style={{
                background: theme == 'black' ? '#000' : 'unset',
                ...style,
            }}
            id="AADS"
            data-section-id={css.AADS}
            data-section-title={title}
        >
            <div className={`content-wrapper ${theme}`}>
                <p className="title">{title}</p>
                <p className="desc">{desc}</p>
                <div className="img-wrapper-small">
                    {items.map((item: any, k: number) => (
                        <div className="panel" key={k}>
                            <NextImage src={item.img} alt={item.title} aria-label={item.title} />
                            <div className="text-wrapper">
                                <p className="sub-title">{item.subtitle}</p>
                                <p className="title">{item.title}</p>
                                <p className="desc">{item.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="img-wrapper-big">
                    {senceList.map((item, k) => (
                        <div className="panel" key={k}>
                            <div className="left">
                                <p className="sub-title">{item.subTitle}</p>
                                <p className="title">{item.title}</p>
                                <p className="desc">{item.desc}</p>
                            </div>
                            <div className="right">
                                <NextImage src={item.img} alt={'EcoFlow app'} aria-label={'EcoFlow app'} />
                            </div>
                        </div>
                    ))}
                </div>
                <div className="download-wrapper">
                    <p>{tip}</p>
                    <div className="icons">
                        <Link href={APP_IOS} dataLayer={getAppDataLayer('App Store')}>
                            <NextImage src={require('@publicLocal/app-point/app_store.png')} alt={'EcoFlow app'} aria-label={'EcoFlow app'} />
                        </Link>
                        <Link href={APP_ANDROID} dataLayer={getAppDataLayer('Google Play')}>
                            <NextImage src={require('@publicLocal/app-point/google_play.png')} alt={'EcoFlow app'} aria-label={'EcoFlow app'} />
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
